<template>
  <div class="modal-content send-document-modal">
    <div class="modal-header">
      <h5 class="modal-title">Отправить {{ document.name }}</h5>
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div
        class="send-document-modal__body d-flex form-group align-items-center"
      >
        <select
          class="form-control custom-select w-75"
          v-model="selectedEmail"
          id="selectFroomBasket"
        >
          <option
            v-for="email in emails"
            :key="email"
            :value="email"
            :selected="email === selectedEmail"
          >
            {{ email }}
          </option>
        </select>
        <label class="mx-2" for="customEmail">другой</label>
        <masked-input
          :options="{
            alias: 'email',
            showMaskOnHover: false,
            showMaskOnFocus: false,
            clearIncomplete: true,
            placeholder: '',
          }"
          class="form-control"
          v-model="customEmail"
          :disabled="selectedEmail !== customEmailOption"
        ></masked-input>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="$emit('close')">
        Закрыть
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="sendEmail"
        :disabled="!email"
      >
        отправить
      </button>
    </div>
  </div>
</template>

<script>
import api from '../../api'
import maskedInput from '../../components/masked-input.vue'

const customEmailOption = 'Другой'

export default {
  name: 'SendDocumentModal',
  components: {
    'masked-input': maskedInput
  },
  props: {
    document: {
      type: Object,
      required: true
    },
    companyEmails: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedEmail: null,
      customEmail: '',
      customEmailOption
    }
  },
  created () {
    this.selectedEmail = this.companyEmails.find((x) => x.isDefault).email
  },
  computed: {
    emails () {
      return [...this.companyEmails.map((x) => x.email), customEmailOption]
    },
    email () {
      return this.selectedEmail && this.selectedEmail !== customEmailOption
        ? this.selectedEmail
        : this.customEmail
    }
  },
  methods: {
    async sendEmail () {
      try {
        await api.post.sendDocumentByEmail(this.document.id, this.email)
        this.$emit('close')
        this.$notify({
          message: `Документ ${this.document.name} отправлен`,
          type: 'success'
        })
      } catch {
        this.$notify({
          message: `Документ ${this.document.name} не отправлен`,
          type: 'danger'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.send-document-modal__body {
  min-height: 100px;
}
</style>
